module.exports = __webpack_public_path__ + "850e76c955d2bdaabffcb1cbbdba1f32.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/diamond/images/diamond_pattern_on_white_left.png
// module id = 860
// module chunks = 0